module.exports = __webpack_public_path__ + "img/bs2.0ebba5cf.png";